import React, { FC, useCallback, useState } from 'react';

import { BaseControlName } from '../../../types/controls';
import { SettingPopupButton } from '../../skin/setting-popup-button/component';
import { PlayerContentType } from '../../../types/content';
import { useChangeSubtitlesPositionCallback } from '../../../hooks/skin/use-change-subtitles-position-callback';
import { EpisodeNavigatorPopupButtonAnalytics } from '../episode-navigator-popup-button/analytics';
import MoviePlayerControlPanel from '../../../../movie-player/ui/MoviePlayerControlPanel';
import { EpisodeAudioSettingsPopupButtonContainer } from '../../../../episode-player/ui/episode-player/EpisodeAudioSettingsPopupButtonContainer';
import { EpisodeTimelinePreviewContainer } from '../../../../episode-player/ui/episode-player/EpisodeTimelinePreviewContainer';
import { NextEpisodeControlContainer } from '../../../../episode-player/ui/episode-player/NextEpisodeControlContainer';

interface Props {
    contentId: string;
    filmId: string;
    seasonId: string;
    psid: string;
    setIsHidingControlsBlocked: (isHidingControlsBlocked: boolean) => void;
    onSelectEpisode?: () => void;
    className?: string;
}

const EpisodePlayerControlPanel: FC<Props> = ({
    contentId,
    filmId,
    seasonId,
    className,
    psid,
    setIsHidingControlsBlocked,
    onSelectEpisode,
}) => {
    const [isSubtitleSizeSettingsForceOpened, setIsSubtitleSizeSettingsForceOpened] =
        useState(false);

    const changeSubtitlePosition = useChangeSubtitlesPositionCallback();
    const onPopupToggle = useCallback(
        (isPopupOpened: boolean) => {
            setIsHidingControlsBlocked(isPopupOpened);
            changeSubtitlePosition(isPopupOpened);
        },
        [setIsHidingControlsBlocked, changeSubtitlePosition]
    );

    return (
        <MoviePlayerControlPanel
            contentId={contentId}
            className={className}
            onPopupToggle={onPopupToggle}
            renderTimelineCursor={
                contentId
                    ? (time) => (
                          <EpisodeTimelinePreviewContainer time={time} contentId={contentId} />
                      )
                    : undefined
            }
            renderLeftControls={() => <NextEpisodeControlContainer contentId={contentId} />}
            renderRightControls={() => (
                <>
                    <EpisodeNavigatorPopupButtonAnalytics
                        contentId={contentId}
                        filmId={filmId}
                        seasonId={seasonId}
                        name={BaseControlName.EPISODE_LIST}
                        psid={psid}
                        onSelectEpisode={onSelectEpisode}
                    />
                    <EpisodeAudioSettingsPopupButtonContainer
                        contentId={contentId}
                        name={BaseControlName.AUDIO_SUBS_LIST}
                        onSubtitleSizeSettingsClick={() =>
                            setIsSubtitleSizeSettingsForceOpened(true)
                        }
                    />
                    <SettingPopupButton
                        name={BaseControlName.ADJUSTMENT}
                        contentId={contentId}
                        contentType={PlayerContentType.EPISODE}
                        isSubtitleSizeSettingsForceOpened={isSubtitleSizeSettingsForceOpened}
                        setIsSubtitleSizeSettingsForceOpened={setIsSubtitleSizeSettingsForceOpened}
                    />
                </>
            )}
        />
    );
};

export default EpisodePlayerControlPanel;
